import React from 'react';
import Suggester from 'src/components/Suggester';
import { useSuggestions } from 'src/hooks/useSuggestions';
import { MPEvents } from 'src/utils/mixpanel/types';
import { mpEvent } from 'src/utils/mixpanel';
import useActionsApp from 'src/redux/actionHooks/useActionsApp';
import { WizardRecomendedControlsIntent } from 'src/redux/reducers/app/types';
import { AssessmentQuery } from 'src/graphql/_generated';

interface AiSuggestControlProps {
  wrapperStyle?: React.CSSProperties;
  assessment: NonNullable<AssessmentQuery['assessment']>;
}

export const AiSuggestControl: React.FC<AiSuggestControlProps> = ({ wrapperStyle, assessment }) => {
  const { saveKeys, hiddenSuggestionKeys } = useSuggestions();
  const id = `${assessment.id}-control`;
  const isHidden = !!id && hiddenSuggestionKeys.includes(id);
  const { setWizardRecomendedControls } = useActionsApp();

  if (isHidden) return null;

  return (
    <div style={wrapperStyle}>
      <Suggester
        key={id}
        onClose={() => {
          const newKeys = [...hiddenSuggestionKeys, id];
          saveKeys(newKeys);
        }}
        title={
          <span>
            You have risk scenarios without controls. See{' '}
            <span
              className="sg-action"
              data-cy="ai-suggest-control-link-controls"
              onClick={() => {
                setWizardRecomendedControls({
                  intent: {
                    type: WizardRecomendedControlsIntent.linkControls,
                    params: { assessmentId: assessment.id, assessmentName: assessment.name },
                  },
                });

                mpEvent(MPEvents.ButtonClick, {
                  button: 'Suggested controls',
                  tags: ['ASSESSMENT', 'RMP', 'AI'],
                });
              }}
            >
              suggested controls
            </span>{' '}
            for each.
          </span>
        }
      />
    </div>
  );
};
